import { BaseStorage } from '../lib/index.mjs';

const getLocalStorage = (options) => {
  if (typeof window === "undefined" || !("localStorage" in window)) {
    return;
  }
  return new BaseStorage(localStorage, options);
};

export { getLocalStorage };
//# sourceMappingURL=index.mjs.map
